import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconRetouch: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="retouch, face, hair"><path d="M17 1L18.0804 3.91964L21 5L18.0804 6.08036L17 9L15.9196 6.08036L13 5L15.9196 3.91964L17 1Z" fill="currentColor"/><path d="M17.25 10.75H6.75V15C6.75 17.8995 9.10051 20.25 12 20.25C14.8995 20.25 17.25 17.8995 17.25 15V10.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M2.75 21V12C2.75 6.89137 6.89137 2.75 12 2.75M21.25 21V12C21.25 10.9499 21.075 9.94076 20.7527 9" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconRetouch;
